import { render } from "./ReceivePOMModal.vue?vue&type=template&id=faba59b6&scoped=true"
import script from "./ReceivePOMModal.vue?vue&type=script&lang=js"
export * from "./ReceivePOMModal.vue?vue&type=script&lang=js"

import "./ReceivePOMModal.vue?vue&type=style&index=0&id=faba59b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faba59b6"]])

export default __exports__